import { useEffect, useState } from 'react';
import styled from 'styled-components';

import Button from 'components/modules/button/Button';
import Modal from 'components/modules/modal/Modal';

interface ModalMemoProps {
  info: any;
  onClose: (isSend: boolean, title: string, content: string) => void;
}

interface IMessage {
  title: string;
  content: string;
}

const ModalMessage = ({ info, onClose }: ModalMemoProps) => {
  const [isShow, setShow] = useState(false);
  const [message, setMessage] = useState<IMessage>({
    title: '',
    content: '',
  });

  const onChangeTitle = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;
    setMessage((prev) => {
      return {
        ...prev,
        title: value,
      };
    });
  };
  const onChangeContent = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.currentTarget.value;
    setMessage((prev) => {
      return {
        ...prev,
        content: value,
      };
    });
  };

  const _Close = () => {
    setShow(false);
    onClose(false, message.title, message.content);
  };

  const onSave = async () => {
    try {
      setShow(false);
      onClose(true, message.title, message.content);
    } catch (error) {
      return;
    }
  };

  useEffect(() => {
    if (info.show) {
      setShow(true);
    }
  }, [info]);

  return (
    <Modal isOpen={isShow} onClose={() => _Close()}>
      <ModalTemplate>
        <HeaderWrap>
          <HeaderTitle>해재대원 문자 발송({info.count}명)</HeaderTitle>
        </HeaderWrap>

        <TitleWrapp>
          <LocWrap>
            <SubTitleWrap>제목</SubTitleWrap>
            <TitleInput placeholder="제목을 입력하세요" value={message.title} onChange={onChangeTitle} />
          </LocWrap>
        </TitleWrapp>

        <ContentsWrap>
          <LocWrap>
            <SubTitleWrap>내용</SubTitleWrap>
            <LocTextArea placeholder="내용을 입력하세요" rows={2} value={message.content} onChange={onChangeContent} />
          </LocWrap>
        </ContentsWrap>

        <ButtonWrap>
          <Button title="취소" color="secondary" onClick={() => _Close()} />
          <Button title="전송하기" onClick={onSave} />
        </ButtonWrap>
      </ModalTemplate>
    </Modal>
  );
};

const ModalTemplate = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(100%);
  flex-flow: column nowrap;
  background-color: #abc9df;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
`;
const HeaderWrap = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  background-color: #11497e;
  border-radius: 10px 10px 0 0;
`;
const HeaderTitle = styled.div`
  display: flex;
  width: 100%;
  height: 50px;
  align-items: center;
  margin-left: 20px;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
`;
const TitleWrapp = styled.div`
  padding: 10px 10px;
  display: flex;
  flex-flow: column nowrap;
  @media (max-width: 319px) {
    padding: 0 10px;
  }
`;
const ContentsWrap = styled.div`
  padding: 0 10px;
  display: flex;
  flex-flow: column nowrap;
  @media (max-width: 319px) {
    padding: 0 10px;
  }
`;
const LocWrap = styled.div`
  position: relative;
  padding: 0 15px;
  flex: 0 0 auto;
  display: flex;
  flex-flow: row nowrap;
  align-items: baseline;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
`;
const SubTitleWrap = styled.div`
  position: relative;
  padding-right: 10px;
  flex: 0 0 auto;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
`;
const TitleInput = styled.input`
  flex: 0 0 auto;
  border-radius: 10px;
  padding: 12px;
  width: 75%;
  min-width: 200px;
  min-height: 50px;
  background-color: #f2f2f2;
  border: 2px solid #dddddd;
  font-size: 16px;
  font-weight: 500;
  resize: none;
  line-height: 30px;

  ::placeholder {
    text-align: center;
    color: #000000;
    position: absolute;
    line-height: 20px;
  }
`;
const LocTextArea = styled.textarea`
  flex: 0 0 auto;
  border-radius: 10px;
  padding: 12px;
  width: 75%;
  min-width: 200px;
  min-height: 200px;
  background-color: #f2f2f2;
  border: 2px solid #dddddd;
  font-size: 16px;
  font-weight: 500;
  resize: none;

  ::placeholder {
    text-align: center;
    color: #000000;
    position: absolute;
    line-height: 20px;
  }
`;
const ButtonWrap = styled.div`
  padding: 20px;
  flex: 0 0 auto;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;

  button {
    margin: 0 5px;
    border-radius: 10px;
    min-height: 40px;
    max-width: 140px;
    cursor: pointer;
  }
`;

export default ModalMessage;
